import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "../../helpers/http";
import { useDispatch, useSelector } from "react-redux";
import { getOutletLink, placeholderHandler } from "../../helpers/help";
import {
  updateFullScreenLoader,
  updateOnboardingState,
} from "../../redux/actions/authActions";
import { Rating } from "react-simple-star-rating";
import useCurrentPosition from "../../helpers/customHooks/useCurrentPosition";
import Auth from "../../auth/Auth";
import { toast } from "react-toastify";
import { WISHLIST } from "../../eums/messages";
import CardLoader from "../widgets/CardLoader";
// import { updateWishistCartCount } from "../../redux/actions/generalActions";
import { updateRestaurantList } from "../../redux/actions/restaurantActions";
import Pagination from "../pagination/Pagination";

const Favorites = () => {
  const dispatch = useDispatch();
  const { cuisineId } = useParams();
  const { latitudeData, longitudeData } = useCurrentPosition();
  const restaurantList = useSelector((state) => state.restaurant.list);
  const isLoading = useSelector((state) => state.auth.isLoading);
  const [view, setView] = useState(false);
  const [loading, setLoading] = useState(null);
  const [page, setPage] = useState(1);

  const restaurant = () => {
    dispatch(updateFullScreenLoader(true));
    let apiParams = new URLSearchParams();
    apiParams.append("page", page);
    apiParams.append("size", 10);
    apiParams = `?${apiParams.toString()}`;

    http(
      {
        method: "POST",
        url: `listRestaurant${apiParams}`,
        isSecure: true,
        body: {
          latitude: latitudeData,
          longitude: longitudeData,
          type: "Take Out",
          favorites: 1,
          ...(cuisineId && { cuisineId: [cuisineId] }),
        },
      },
      (res) => {
        dispatch(updateRestaurantList(res));
        dispatch(updateFullScreenLoader(false));
      }
    );
  };

  useEffect(() => {
    if (latitudeData && longitudeData) {
      dispatch(updateFullScreenLoader(true));
      restaurant();
    }
  }, [latitudeData, longitudeData, page]);

  // const handleFavourite = (data, index) => {
  //   if (!Auth.isUserAuthenticated()) {
  //     dispatch(updateOnboardingState("login"));
  //     return;
  //   }
  //   const newStatus = data.is_like ? 0 : 1;
  //   setLoading(data.outlet[0].outletId);
  //   http(
  //     {
  //       method: "POST",
  //       url: `addOutletToUserFavourite`,
  //       isSecure: true,
  //       body: {
  //         outletId: data.outlet[0].outletId,
  //         status: newStatus,
  //       },
  //     },
  //     (res) => {
  //       if (res.error === "false") {
  //         toast.success(data.is_like ? WISHLIST.DISLIKE : WISHLIST.LIKE);
  //         restaurantList.listRestaurants.splice(index, 1);
  //         dispatch(updateRestaurantList({ ...restaurantList }));
  //         // dispatch(updateWishistCartCount());
  //         setLoading(false);
  //       }
  //     }
  //   );
  // };

  return (
    <>
      <main>
        <div className="restaurant_inner_bg needmin-hmain">
          <div className="cus_container">
            <h1 className="head1 text-center">Favorites</h1>
          </div>
        </div>
      </main>
      <section className="restaurantsNear favorite">
        {!!restaurantList.listRestaurants?.length || isLoading ? (
          <div className="cus_container">
            <div className="d-md-flex mobileview_TFDC">
              <div className="restaurant_view_all">
                <div className="d-flex justify-content-end align-items-center mb-sm-5 mb-0">
                  <div className="col-right d-sm-block d-none">
                    <div className="custab_btn d-flex">
                      <button
                        onClick={() => setView(false)}
                        className={`${view === false ? "active" : ""} tabbtn`}
                      >
                        <img
                          src="./assets/img/unGrid_white.svg"
                          alt="arrow back"
                          className="Active_grout-item"
                        />
                        <img
                          src="./assets/img/unGrid.svg"
                          alt="arrow back"
                          className="deActive_grout-item"
                        />
                      </button>
                      <button
                        onClick={() => setView(true)}
                        className={`${view ? "active" : ""} tabbtn`}
                      >
                        <img
                          src="./assets/img/grid_item_img.svg"
                          alt="grid active"
                          className="Active_grout-item"
                        />
                        <img
                          src="./assets/img/grid_item_img_black.svg"
                          alt="grid deactive"
                          className="deActive_grout-item"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="view_data_resaurant">
                  {view === false ? (
                    <div className="grid_item_single">
                      <div className="restaurants_container">
                        <div className="restaurants_group">
                          {restaurantList.listRestaurants &&
                            restaurantList.listRestaurants.map(
                              (item, index) => (
                                <div
                                  key={item.restaurantId}
                                  className="res-box restaurants_item"
                                >
                                  {loading === item.outlet[0].outletId && (
                                    <CardLoader />
                                  )}
                                  <Link
                                    key={index}
                                    state={{ item }}
                                    className="d-flex  w-100  flex-sm-row flex-column"
                                    to={getOutletLink(item.outlet[0])}
                                  >
                                    <div className="res_img resimg_fix">
                                      <img
                                        onError={placeholderHandler}
                                        src={item.restaurantImage}
                                        alt="restaurant"
                                        className="restaurant-img"
                                      />
                                    </div>
                                    <div className="res_content dgrid mt-2">
                                      <div className="my-sm-2 my-1 d-flex align-items-center justify-content-between">
                                        <h6 className="head6">
                                          {item.restaurantName}
                                        </h6>
                                      </div>
                                      <p className="txt my-sm-2 my-1">
                                        {item.outlet.map((food) => {
                                          return food.foodTag.map(
                                            (tag, index) => {
                                              return (
                                                <span
                                                  className="me-2"
                                                  key={"tag" + index}
                                                >
                                                  {tag.itemName +
                                                    `${tag &&
                                                      food?.foodTag?.length -
                                                      1 !==
                                                      index
                                                      ? ","
                                                      : ""
                                                    }`}
                                                </span>
                                              );
                                            }
                                          );
                                        })}
                                      </p>
                                      <div className="ratting_sec d-flex align-items-center justify-content-between">
                                        <div className="review_start">
                                          <Rating
                                            initialValue={item.averageReview}
                                            readonly
                                          />
                                        </div>
                                        {/* <div className="heart-img">
                                            <img
                                              src="./assets/img/wishlist-heart-icon-0.svg"
                                              alt="grat heart"
                                            />
                                          </div> */}
                                      </div>
                                      {item?.emergency_close === 0 ? (
                                        <div className="btn_res open">Open</div>
                                      ) : (
                                        <div className="btn_res close d-inline-block mt-3">
                                          Close
                                        </div>
                                      )}
                                    </div>
                                  </Link>
                                  <div
                                    className="heart-img pointer oneLineResH"
                                  // onClick={() => handleFavourite(item, index)}
                                  >
                                    <img
                                      src={`./assets/img/wishlist-heart-icon-${item.is_like}.svg`}
                                      alt="grat heart"
                                    />
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="favorites_restaurant">
                      <div className="restaurants_group">
                        {restaurantList.listRestaurants &&
                          restaurantList.listRestaurants.map((item, index) => (
                            <div
                              key={item.restaurantId}
                              className="res-box restaurants_item"
                            >
                              {loading === item.outlet[0].outletId && (
                                <CardLoader />
                              )}
                              <Link
                                key={index}
                                state={{ item }}
                                className="restaurants_item_in"
                                to={getOutletLink(item.outlet[0])}
                              >
                                <div className="res_img">
                                  <img
                                    onError={placeholderHandler}
                                    src={item.restaurantImage}
                                    alt="restaurant"
                                    className="restaurant-img"
                                  />
                                </div>
                                <div className="res_content">
                                  <div className="my-2 d-flex align-items-center justify-content-between">
                                    <h6 className="head6 text-break">
                                      {item.restaurantName}
                                    </h6>
                                    {item?.emergency_close === 0 ? (
                                      <div className="btn_res open m-0">
                                        Open
                                      </div>
                                    ) : (
                                      <div className="btn_res close m-0">
                                        Close
                                      </div>
                                    )}
                                  </div>
                                  <p className="txt my-2">
                                    {item.outlet.map((food) => {
                                      return food.foodTag.map((tag, index) => {
                                        return (
                                          <span
                                            className="me-2"
                                            key={"tag" + index}
                                          >
                                            {tag.itemName},
                                          </span>
                                        );
                                      });
                                    })}
                                  </p>
                                  <div className="ratting_sec d-flex align-items-center justify-content-between">
                                    <div className="review_start">
                                      <Rating
                                        initialValue={item.averageReview}
                                        readonly
                                      />
                                    </div>
                                    {/* <div className="heart-img">
                                      <img
                                        src="./assets/img/wishlist-heart-icon-0.svg"
                                        alt="grat heart"
                                      />
                                    </div> */}
                                  </div>
                                </div>
                              </Link>
                              <div
                                className="heart-img pointer"
                                // onClick={() => handleFavourite(item, index)}
                                style={{ bottom: "17px" }}
                              >
                                <img
                                  src={`./assets/img/wishlist-heart-icon-${item.is_like}.svg`}
                                  alt="grat heart"
                                />
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                  <div className="mt-3">
                    {restaurantList.total_pages > 1 && (
                      <Pagination
                        totalPages={restaurantList?.total_pages}
                        currentPage={page}
                        page={page}
                        setPage={(page) => setPage(page)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="text-center middle-line-RL mt-5">
                        <a href="restaurant" className="hoverbtn btnsize17 d-block m-auto">View More</a>
                    </div> */}
          </div>
        ) : (
          <h3 className="text-center">No Favorites List</h3>
        )}
      </section>
    </>
  );
};

export default Favorites;
